import React from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../firebase';
import GetInvolved from '../components/GetInvolved';
import Cta from '../components/Cta';
import Footer from '../components/Footer';
import Hero from '../components/Hero';
import Intro from '../components/Intro';
import Partners from '../components/Partners';
import AddEventForm from "../components/AddEventForm";
import FeaturedArticles from '../components/FeaturedArticles';
import { Link } from 'react-router-dom';


const Home = () => {
    const [user] = useAuthState(auth);

    return (
        <>
            <Hero />
            <Intro />

            {/* Community Moments — leads into Partners */}
            <section className="py-12 px-4 bg-gray-50 border-t border-gray-100">
                <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-6 text-center sm:text-left">
                    <p className="text-gray-600 text-lg leading-relaxed max-w-xl">
                        From shoe drives to community runs, every moment tells our story.{' '}
                        <Link
                            to="/photo-library"
                            className="text-black font-semibold underline underline-offset-4 decoration-2 hover:text-gray-500 transition-colors"
                        >
                            Browse our photo library
                        </Link>{' '}
                        to see the impact we're making together.
                    </p>
                    <Link
                        to="/photo-library"
                        className="flex-shrink-0 inline-flex items-center gap-2 bg-black text-white px-7 py-3 rounded-xl text-base font-medium shadow-sm hover:bg-gray-800 transition-all hover:scale-[1.02]"
                    >
                        View Photos
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                        </svg>
                    </Link>
                </div>
            </section>

            <Partners />
            <GetInvolved />
            {user && <AddEventForm />}
            <Cta />
            <FeaturedArticles />
            <Footer />
        </>
    );
};

export default Home;
